const guia = {
  hero: {
    badge: '市场情报',
    title1: '社区与城市',
    title2: ' 价格指南 2025',
    description: '了解迈阿密（美国佛罗里达州）、圣保罗和巴西利亚的每平方米/平方英尺平均价格、年度趋势和社区评分等本地市场价值。',
    statCities: '3 座城市',
    statNeighborhoods: '20 个社区',
    statTrends: '5 年趋势',
    statAi: 'AI 生成数据',
  },
  pulse: {
    title: '市场脉搏',
    subtitle: '3 个市场 · 最新动态',
    updated: '更新于',
    viewGuide: '查看指南',
    recentUpdates: '条最新动态',
    badgePrices: '价格',
    badgeTrend: '趋势',
    disclaimer: '<0>仅供教育目的 — AI 生成数据免责声明：</0>本页面展示的每平方米/平方英尺平均价格、年度增长率和社区评分是 AI 生成的估算值，汇编自公开市场报告、房地产指数（FipeZAP、ZAP Imóveis、CondoBlackBook）以及 2024–2025 年的第三方来源。这些数据可能过时、不完整或不准确。仅供一般教育和信息参考，不构成金融、投资或房地产建议。<1>Carvalho\'s Imobiliária 对基于此信息产生的任何错误、遗漏或决策不承担任何责任。</1>在做出任何投资决策之前，请务必咨询持牌房地产专业人士并进行独立的尽职调查。',
  },
  citySelector: {
    title: '选择城市',
    subtitle: '点击探索社区和价格数据',
    selected: '已选择',
    listings: '房源',
    avgPrice: '均价',
    yoyGrowth: '年度增长',
    viewFullGuide: '查看完整指南',
  },
  miamiDetail: {
    description: '迈阿密是全球最具活力的豪宅市场之一，吸引着国际投资者和超高净值买家。这座城市融合了热带生活方式、世界级配套设施和强劲的升值潜力。2025 年，豪华公寓均价首次突破每平方英尺 1,000 美元。',
    avgPrice: '均价',
    yoyGrowth: '年度增长',
    neighborhoods: '社区',
    activeListings: '在售房源',
    priceEvolution: '均价走势',
    since2020: '自 2020 年以来 +54.5%',
    currentAvg: '当前均价（2025）',
    neighborhoodsTitle: '迈阿密社区',
    neighborhoodsFound: '找到 7 个社区',
    searchPlaceholder: '搜索社区...',
    sortPrice: '价格',
    sortGrowth: '增长率',
    sortAZ: 'A–Z',
    pricePerSqft: '每平方英尺均价',
    yoyVar: '年度变化',
    walkability: '步行便利性',
    infrastructure: '基础设施',
    appreciation: '升值潜力',
    viewFullGuide: '查看完整指南',
  },
  priceTable: {
    title: '完整价格对比',
    subtitle: '所有社区按单位均价排序',
    colNeighborhood: '社区',
    colCity: '城市',
    colAvgPrice: '均价',
    colYoY: '年度变化',
    colMarketType: '市场类型',
    colListings: '房源',
  },
  compare: {
    title: '交互工具',
    subtitle: '并排比较市场',
    description: '选择两个市场，比较价格、收益率、投资评分和理想配置。',
    marketA: '市场 A',
    marketB: '市场 B',
    metric: '指标',
    overview: '概览',
    returnYield: '回报与收益率',
    investmentScores: '投资评分（0–10）',
    overallScore: '综合评分',
    profileAnalysis: '配置与分析',
    strengths: '优势',
    risks: '主要风险',
    viewAnalysis: '查看完整社区分析',
    viewMiamiGuide: '查看迈阿密指南',
    viewSPGuide: '查看圣保罗指南',
    footerNote: '评分是基于公开指数（FipeZAP、Zillow，2025 年第一季度）的编辑估算。不构成财务建议。',
    of10: '（满分 10 分）',
    currency: '货币',
    entryPrice: '入门价格（最低）',
    avgPrice: '均价',
    topMarket: '市场顶端',
    yoyAppreciation: '年度升值',
    rentalYield: '租金收益率',
    recommendedHorizon: '推荐持有期',
    marketLiquidity: '市场流动性',
    appreciationPotential: '升值潜力',
    passiveIncome: '被动收入',
    idealProfile: '理想投资者配置',
    locationMiami: '美国佛罗里达州',
    locationSP: '巴西圣保罗',
    currencyA: 'USD · 美元',
    currencyB: 'BRL · 巴西雷亚尔',
    yieldA: '每年 5–8%',
    yieldB: '每年 4–6%',
    horizonA: '5–10 年',
    horizonB: '3–10 年',
    idealProfileA: '国际化配置、汇率保护和长期持有（5–10 年）',
    idealProfileB: '最高流动性、社区多样性以及进入拉丁美洲最大金融中心的机会',
    strengthsA: ['佛州 0% 州所得税', '短租可行', '国际化市场', 'BRL/USD 汇率对冲', '五年累计升值 +54%'],
    strengthsB: ['拉美最大市场', '最高流动性', '社区与档次多样', 'Faria Lima 企业中心'],
    risksA: ['汇率风险（BRL/USD）', '维护成本高', '强制保险（飓风）', '非居民手续繁琐'],
    risksB: ['ITBI + 税负较高', '部分社区供应过剩', '升值更为渐进'],
  },
  country: {
    usa: '美国',
    brazil: '巴西',
  },
  cta: {
    title: '准备好在合适的社区投资了吗？',
    specialist: '市场情报专家',
    description: '我们的专家对每个市场了如指掌。立即获取个性化建议。',
    whatsapp: '在 WhatsApp 上与专家交谈',
    browse: '浏览所有房源',
  },
  spHighlight: {
    title: 'Itaim Bibi 在 2026 年 Q1 以 +11.3% 的年度增长率领跑圣保罗',
    subtitle: 'Faria Lima 走廊因国际基金新办公室入驻而保持旺盛需求。',
  },
  brasiliaHighlight: {
    title: 'FipeZAP：DF 在 2025 年以 +12.6% 领跑各首府升值榜',
    subtitle: 'Sudoeste 和 Noroeste 推动上涨 — Plano Piloto 均价达到 R$14,300/m²。',
  },
  miamiHighlight: {
    title: 'Sunny Isles 历史上首次突破每平方英尺 US$2,000',
    subtitle: 'Bentley Residences 和 Porsche Design Tower 将该地区的价格底线推向历史新高。',
  },
  cityPages: {
    shared: {
      marketPulse: '市场脉搏',
      updates: '3 条更新',
      updatedOn: '更新于',
      disclaimerWarning: '免责声明',
      disclaimerMiami: '价格数据是基于公开指数（CondoBlackBook、Zillow，2025 年 Q1）的估算值。不构成财务建议。在做出任何投资决策前，请咨询专业人士。',
      disclaimerBR: '价格数据是基于公开指数（FipeZAP、ZAP Imóveis，2025 年）的估算值。不构成财务建议。在做出任何投资决策前，请咨询专业人士。',
      interactiveTool: '交互工具',
      compareHeading: '并排比较市场',
      compareSubtitle: '选择两个市场，比较价格、收益率、投资评分和理想配置。',
      marketA: '市场 A',
      marketB: '市场 B',
      vs: '对比',
      metric: '指标',
      overview: '概览',
      returnYield: '回报与收益率',
      investmentScores: '投资评分（0–10）',
      overallScore: '综合评分',
      profileAnalysis: '配置与分析',
      idealProfile: '理想投资者配置',
      strengths: '优势',
      risks: '主要风险',
      viewAnalysis: '查看完整社区分析',
      footerNote: '评分是基于公开指数（FipeZAP、Zillow，2025 年 Q1）的编辑估算。不构成财务建议。',
      of10: '（满分 10 分）',
      currency: '货币',
      entryPrice: '入门价格（最低）',
      avgPrice: '均价',
      topMarket: '市场顶端',
      yoyAppreciation: '年度升值',
      rentalYield: '租金收益率',
      recommendedHorizon: '推荐持有期',
      marketLiquidity: '市场流动性',
      appreciationPotential: '升值潜力',
      passiveIncome: '被动收入',
      faqBadge: '常见问题',
      viewAllFaqs: '在 FAQ 中心查看所有问题',
      exploreBadge: '市场指南',
      exploreTitle: '探索其他市场',
      exploreSubtitle: '主要房地产投资目的地的详细分析。',
      exploreViewAll: '查看所有市场',
      avgPriceLabel: '均价',
      yoyLabel: '年度升值',
      viewFullGuide: '查看完整指南',
      colRank: '#',
      colNeighborhood: '社区',
      colPrice: '均价',
      colYoY: '年度变化',
      colProfile: '配置',
      colListings: '房源',
      hot: '热门',
      top: '顶级',
      currencyLabel: '货币',
      ctaWhatsapp: '立即与专家交谈',
      falarConsultor: '与顾问交谈',
    },
    miami: {
      heroBadge: '迈阿密 · 佛罗里达',
      heroTitle: '迈阿密最佳投资社区',
      heroTitleHighlight: '2025 年投资指南',
      heroDescription: '迈阿密已成为巴西投资者在美国的首选房地产投资目的地。均价超过每平方英尺 1,000 美元，历史性的两位数升值，且免征州所得税，这座城市提供了全球最佳的风险调整后回报之一。',
      heroCtaProperties: '查看迈阿密房源',
      heroCtaContact: '与顾问交谈',
      location: '迈阿密，佛罗里达',
      countryLabel: '美国佛罗里达州',
      currencyA: 'USD · 美元',
      currencyB: 'BRL · 巴西雷亚尔',
      strengthsA: ['佛州 0% 州所得税', '短租可行', '国际化市场', 'BRL/USD 汇率对冲', '五年累计升值 +54%'],
      strengthsB: ['拉美最大市场', '最高流动性', '社区与档次多样', 'Faria Lima 企业中心'],
      risksA: ['汇率风险（BRL/USD）', '维护成本高', '强制保险（飓风）', '非居民手续繁琐'],
      risksB: ['ITBI + 税负较高', '部分社区供应过剩', '升值更为渐进'],
      idealProfileA: '国际化配置、汇率保护和长期持有（5–10 年）',
      idealProfileB: '最高流动性、社区多样性以及进入拉丁美洲最大金融中心的机会',
      entryPriceA: 'US$ 400,000',
      entryPriceB: 'R$ 350,000',
      avgPriceA: 'US$ 1,100/sq ft',
      avgPriceB: 'R$ 11,800/m²',
      topMarketA: 'US$ 3,800/sq ft · Bal Harbour',
      topMarketB: 'R$ 32,000/m² · Cidade Jardim',
      yieldA: '每年 5–8%',
      yieldB: '每年 4–6%',
      horizonA: '5–10 年',
      horizonB: '3–10 年',
      liquidityA: '9.2',
      liquidityB: '10.0',
      appreciationA: '9.0',
      appreciationB: '7.0',
      passiveIncomeA: '8.0',
      passiveIncomeB: '7.0',
      overallScoreA: '8.7',
      overallScoreB: '8.0',
      scoreWidthA: '87%',
      scoreWidthB: '80%',
      viewGuideA: '查看迈阿密指南',
      viewGuideB: '查看圣保罗指南',
      whyInvestTitle: '为什么投资迈阿密？',
      whyInvestSubtitle: '使迈阿密成为巴西人在美国最大房地产投资目的地的 4 大理由。',
      neighborhoodsTitle: '迈阿密社区 — 完整分析',
      neighborhoodsSubtitle: '点击任意社区查看详细价格、评分和市场亮点。',
      rankingTitle: '价格排名 — 迈阿密社区',
      rankingSubtitle: '按每平方英尺均价排序的比较 · 2025 年 Q1',
      howToBuyBadge: '巴西人购房指南',
      howToBuyTitle: '巴西人如何在迈阿密购买房产',
      howToBuySubtitle: '为巴西投资者在美国购置房产的逐步指南，确保法律安全和税务效率。',
      howToBuyHelpTitle: '需要整个流程的帮助？',
      howToBuyHelpSubtitle: '我们的团队指导巴西人从 ITIN 到交钥匙 — 无额外费用。',
      howToBuyHelpCTA: '与专家交谈',
      faqTitle: '关于迈阿密投资的常见问题',
      faqSubtitle: '巴西投资者关于在迈阿密购房的主要疑问 — 由专家解答。',
      exploreCardBrasiliaTitle: '巴西利亚',
      exploreCardBrasiliaSubtitle: '巴西人均收入最高的联邦首都，联合国教科文组织遗产，市场韧性十足。',
      exploreCardBrasiliaBadge: '联邦区',
      exploreCardBrasiliaPrice: 'R$12,000/m²',
      exploreCardBrasiliaYoY: '+12.6%',
      exploreCardBrasiliaYoYLabel: '年度最高涨幅',
      exploreCardSPTitle: '圣保罗',
      exploreCardSPSubtitle: '拉丁美洲最大的房地产市场。Faria Lima、Itaim Bibi 以及持续升值的走廊。',
      exploreCardSPBadge: '巴西圣保罗',
      exploreCardSPPrice: 'R$11,800/m²',
      exploreCardSPYoY: '+8.7%',
      exploreCardSPYoYLabel: '年度升值',
      ctaTitle: '准备好在迈阿密投资了吗？',
      ctaSubtitle: '我们专注于迈阿密房地产的团队为巴西人服务超过 9 年。从 ITIN 到交钥匙。',
      ctaSecondary: '查看迈阿密房源',
    },
    saoPaulo: {
      heroBadge: '圣保罗 · SP',
      heroTitle: '圣保罗最佳投资社区',
      heroTitleHighlight: '2025 年投资指南',
      heroDescription: '圣保罗是巴西的金融之都，也是拉丁美洲最大的房地产市场。拥有超过 1200 万居民，GDP 相当于整个国家的规模，2025 年平均升值率达 +8.7%，这座城市为寻求收入、升值或资产多元化的投资者提供了独特的机会。',
      heroCtaProperties: '查看圣保罗房源',
      heroCtaContact: '与顾问交谈',
      location: '圣保罗，SP',
      countryLabel: '巴西圣保罗',
      currencyA: 'BRL · 巴西雷亚尔',
      currencyB: 'USD · 美元',
      strengthsA: ['拉美最大市场', '最高流动性', '社区与档次多样', 'Faria Lima 企业中心'],
      strengthsB: ['佛州 0% 州所得税', '短租可行', '国际化市场', 'BRL/USD 汇率对冲', '五年累计升值 +54%'],
      risksA: ['ITBI + 税负较高', '部分社区供应过剩', '升值更为渐进'],
      risksB: ['汇率风险（BRL/USD）', '维护成本高', '强制保险（飓风）', '非居民手续繁琐'],
      idealProfileA: '最高流动性、社区多样性以及进入拉丁美洲最大金融中心的机会',
      idealProfileB: '国际化配置、汇率保护和长期持有（5–10 年）',
      entryPriceA: 'R$ 350,000',
      entryPriceB: 'US$ 400,000',
      avgPriceA: 'R$ 11,800/m²',
      avgPriceB: 'US$ 1,100/sq ft',
      topMarketA: 'R$ 32,000/m² · Cidade Jardim',
      topMarketB: 'US$ 3,800/sq ft · Bal Harbour',
      yieldA: '每年 4–6%',
      yieldB: '每年 5–8%',
      horizonA: '3–10 年',
      horizonB: '5–10 年',
      liquidityA: '10.0',
      liquidityB: '9.2',
      appreciationA: '7.0',
      appreciationB: '9.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '8.0',
      overallScoreA: '8.0',
      overallScoreB: '8.7',
      scoreWidthA: '80%',
      scoreWidthB: '87%',
      viewGuideA: '查看圣保罗指南',
      viewGuideB: '查看迈阿密指南',
      whyInvestTitle: '为什么投资圣保罗？',
      whyInvestSubtitle: '使圣保罗成为拉丁美洲最大房地产投资目的地的 4 大理由。',
      neighborhoodsTitle: '圣保罗社区 — 完整分析',
      neighborhoodsSubtitle: '点击任意社区查看详细价格、评分和市场配置。',
      rankingTitle: '价格排名 — 圣保罗社区',
      rankingSubtitle: '按每平方米均价排序的比较 · 2025 年',
      faqTitle: '关于圣保罗房产的常见问题',
      faqSubtitle: '买家和投资者关于拉丁美洲最大房地产市场的主要疑问。',
      exploreCardMiamiTitle: '迈阿密',
      exploreCardMiamiSubtitle: '巴西人在美国的首选目的地 — 强势美元、高收益和国际市场。',
      exploreCardMiamiBadge: '美国佛罗里达州',
      exploreCardMiamiPrice: '$1,100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: '年度升值',
      exploreCardBrasiliaTitle: '巴西利亚',
      exploreCardBrasiliaSubtitle: '巴西人均收入最高的联邦首都，联合国教科文组织遗产，市场韧性十足。',
      exploreCardBrasiliaBadge: '联邦区',
      exploreCardBrasiliaPrice: 'R$12,000/m²',
      exploreCardBrasiliaYoY: '+12.6%',
      exploreCardBrasiliaYoYLabel: '年度最高涨幅',
      ctaTitle: '准备好在圣保罗投资了吗？',
      ctaSubtitle: '我们专注于圣保罗市场的团队指导您从社区选择到合同签署 — 无额外费用。',
      ctaSecondary: '查看圣保罗房源',
    },
    brasilia: {
      heroBadge: '巴西利亚 · 联邦区',
      heroTitle: '巴西利亚最佳购房社区',
      heroTitleHighlight: '2025 年购房指南',
      heroDescription: '巴西利亚 2025 年新房价格上涨 12.6%，在巴西各首府中居首。作为人均收入最高的联邦首都，稳定的公共部门需求和因城市规划保护而自然受限的供应，使这座城市成为全国最具韧性的市场之一。',
      heroCtaProperties: '查看巴西利亚房源',
      heroCtaContact: '与顾问交谈',
      location: '巴西利亚，DF',
      countryLabel: '巴西联邦区',
      currencyA: 'BRL · 巴西雷亚尔',
      currencyB: 'BRL · 巴西雷亚尔',
      strengthsA: ['UNESCO 限制供应', '巴西最高人均收入', '稳定的公共部门需求', '抗危机市场'],
      strengthsB: ['拉美最大市场', '最高流动性', '社区与档次多样', 'Faria Lima 企业中心'],
      risksA: ['流动性偏区域性', '依赖联邦预算', '市场多样化不足'],
      risksB: ['ITBI + 税负较高', '部分社区供应过剩', '升值更为渐进'],
      idealProfileA: '保守型配置，寻求资产安全和公务员稳定租金收入',
      idealProfileB: '最高流动性、社区多样性以及进入拉丁美洲最大金融中心的机会',
      entryPriceA: 'R$ 450,000',
      entryPriceB: 'R$ 350,000',
      avgPriceA: 'R$ 12,000/m²',
      avgPriceB: 'R$ 11,800/m²',
      topMarketA: 'R$ 16,500/m² · Sudoeste',
      topMarketB: 'R$ 32,000/m² · Cidade Jardim',
      yieldA: '每年约 5%',
      yieldB: '每年 4–6%',
      horizonA: '3–7 年',
      horizonB: '3–10 年',
      liquidityA: '7.0',
      liquidityB: '10.0',
      appreciationA: '8.0',
      appreciationB: '7.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '7.0',
      overallScoreA: '7.3',
      overallScoreB: '8.0',
      scoreWidthA: '73%',
      scoreWidthB: '80%',
      viewGuideA: '查看巴西利亚指南',
      viewGuideB: '查看圣保罗指南',
      whyInvestTitle: '为什么投资巴西利亚？',
      whyInvestSubtitle: '使巴西利亚成为巴西最具韧性房地产市场之一的 4 大结构性因素。',
      neighborhoodsTitle: '巴西利亚社区 — 完整分析',
      neighborhoodsSubtitle: '点击任意社区查看详细价格、评分和市场配置。',
      rankingTitle: '价格排名 — 巴西利亚社区',
      rankingSubtitle: '按每平方米均价排序的比较 · 2025 年',
      faqTitle: '关于巴西利亚房产的常见问题',
      faqSubtitle: '买家和投资者关于巴西利亚和联邦区房地产市场的主要疑问。',
      exploreCardMiamiTitle: '迈阿密',
      exploreCardMiamiSubtitle: '巴西人在美国的首选目的地 — 强势美元、高收益和国际市场。',
      exploreCardMiamiBadge: '美国佛罗里达州',
      exploreCardMiamiPrice: '$1,100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: '年度升值',
      exploreCardSPTitle: '圣保罗',
      exploreCardSPSubtitle: '拉丁美洲最大的房地产市场。Faria Lima、Itaim Bibi 以及持续升值的走廊。',
      exploreCardSPBadge: '巴西圣保罗',
      exploreCardSPPrice: 'R$11,800/m²',
      exploreCardSPYoY: '+8.7%',
      exploreCardSPYoYLabel: '年度升值',
      ctaTitle: '准备好在巴西利亚投资了吗？',
      ctaSubtitle: '我们专注于联邦区市场的团队指导您从社区选择到合同签署 — 无额外费用。',
      ctaSecondary: '查看巴西利亚房源',
    },
  },
};

export default guia;